import { SqlRbacAction } from "services/rbac/action";
import { Privilege, PrivilegeObjectType } from "services/rbac/types";

import { ANY_OBJECT_NAME } from "components/App/accessManager";

export const createAccountPrivilege = {
  objectType: PrivilegeObjectType.organization,
  objectName: ANY_OBJECT_NAME,
  privilegeType: SqlRbacAction.CREATE_ACCOUNT,
};

export const accountsPrivileges = [
  {
    objectType: PrivilegeObjectType.account,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
  {
    objectType: PrivilegeObjectType.account,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.USAGE,
  },
  {
    objectType: PrivilegeObjectType.organization,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY_ANY_ACCOUNT,
  },
  createAccountPrivilege,
];

export const createLoginPrivilege = {
  objectType: PrivilegeObjectType.organization,
  objectName: ANY_OBJECT_NAME,
  privilegeType: SqlRbacAction.CREATE_LOGIN,
};

export const loginsPrivileges = [
  {
    objectType: PrivilegeObjectType.login,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
  {
    objectType: PrivilegeObjectType.login,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.USAGE,
  },
  {
    objectType: PrivilegeObjectType.organization,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY_ANY_LOGIN,
  },
  createLoginPrivilege,
];

export const createNetworkPolicyPrivilege = {
  objectType: PrivilegeObjectType.organization,
  objectName: ANY_OBJECT_NAME,
  privilegeType: SqlRbacAction.CREATE_NETWORK_POLICY,
};

export const networkPoliciesPrivileges = [
  {
    objectType: PrivilegeObjectType.network_policy,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
  {
    objectType: PrivilegeObjectType.network_policy,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.USAGE,
  },
  {
    objectType: PrivilegeObjectType.organization,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY_ANY_NETWORK_POLICY,
  },
  createNetworkPolicyPrivilege,
];

export const createServiceAccountPrivilege = {
  objectType: PrivilegeObjectType.organization,
  objectName: ANY_OBJECT_NAME,
  privilegeType: SqlRbacAction.CREATE_SERVICE_ACCOUNT,
};

export const serviceAccountsPrivileges = [
  {
    objectType: PrivilegeObjectType.service_account,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
  {
    objectType: PrivilegeObjectType.service_account,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.USAGE,
  },
  {
    objectType: PrivilegeObjectType.organization,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY_ANY_SERVICE_ACCOUNT,
  },
  createServiceAccountPrivilege,
];

export const ssoPrivileges = [
  {
    objectType: PrivilegeObjectType.organization,
    objectName: ANY_OBJECT_NAME, // As we have only one organization, we can use ANY_OBJECT_NAME
    privilegeType: SqlRbacAction.MODIFY,
  },
];

export const organizationDetailsPrivileges = [
  {
    objectType: PrivilegeObjectType.organization,
    objectName: ANY_OBJECT_NAME, // As we have only one organization, we can use ANY_OBJECT_NAME
    privilegeType: SqlRbacAction.MODIFY,
  },
];

export const createOrgRolePrivilege = {
  objectType: PrivilegeObjectType.organization,
  objectName: ANY_OBJECT_NAME,
  privilegeType: SqlRbacAction.CREATE_ORGANIZATION_ROLE,
};

export const orgRolesPrivileges: Privilege[] = [
  {
    objectType: PrivilegeObjectType.organization_role,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
  {
    objectType: PrivilegeObjectType.organization_role,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.USAGE,
  },
  {
    objectType: PrivilegeObjectType.organization,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY_ANY_ORGANIZATION_ROLE,
  },
  createOrgRolePrivilege,
];

// should match at least one of the privileges in the array
export const configureSectionPrivileges = [
  ...accountsPrivileges,
  ...loginsPrivileges,
  ...networkPoliciesPrivileges,
  ...serviceAccountsPrivileges,
  ...ssoPrivileges,
  ...organizationDetailsPrivileges,
  ...orgRolesPrivileges,
];
